import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import ClassDetails from '@app/components/teachers/Statistics/ClassDetails'
import Loader from '@app/components/ui/placeholders/Loader'
import * as teacherActions from '@app/actions/teachers'
import { sortedClasses } from '@app/helpers/classesHelper'
import { AbilityContext } from '@app/context/ability-context'

class StatisticsContainer extends Component {
  static contextType = AbilityContext;

  constructor(props) {
    super(props)

    const { dispatch } = props
    this.boundActions = bindActionCreators(teacherActions, dispatch)
  }

  componentDidMount() {
    this.updateIfNeeded()
  }

  async updateIfNeeded() {
    await this.boundActions.fetchClassesIfNeeded()
    if (!this.group) { return }

    const ability = this.context

    if (ability.can('read', 'Statistic', 'preparatory')) {
      this.boundActions.fetchStatisticsIfNeeded(this.group.object.id, 'preparatory')
    }

    if (ability.can('read', 'Statistic', 'trial')) {
      this.boundActions.fetchStatisticsIfNeeded(this.group.object.id, 'trial')
    }

    if (ability.can('read', 'Statistic', 'main')) {
      this.boundActions.fetchStatisticsIfNeeded(this.group.object.id, 'main')

      if (ability.can('read', 'Diplomas')) {
        this.boundActions.fetchDiplomasIfNeeded(this.group.object.id, this.props.global.event.id)
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.route != this.props.route) {
      this.updateIfNeeded()
    }
  }

  get group() {
    const { classes: { objects } } = this.props
    const { route: { match: { params: { id } } } } = this.props

    var group = objects[id]
    if (!group) { group = _.first(_.values(objects)) }

    return group
  }

  get olympiad() {
    return _.find(this.props.olympiads, ['grade', this.group.object.grade])
  }

  render() {
    const { classes: { fetching }, global: { event } } = this.props

    if (!this.group && fetching) { return <Loader /> }
    if (!this.group) { return null }

    const { route, classes: { objects } } = this.props
    return (
      <ClassDetails
        classes={sortedClasses(objects)}
        group={this.group}
        olympiad={this.olympiad}
        route={route}
        ability={this.context}
        event={event}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const { teachers: { classes }, global: { olympiads } } = state;
  return { classes, olympiads }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, {
    getDisplayName: () => 'Statistics'
  }
)(StatisticsContainer)
